import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { webApiUrl } from '@domains/shared/domain/utils/url';
import { Observable } from 'rxjs';

/**
 * Obnova cookie k firemním obrázkům a videím (EL-2301).
 *
 * ⚠ **Schválně mimo interceptory** (`HttpBackend`, ne běžný `HttpClient`). Požadavek
 * jde na pozadí, když se karta znovu ukáže, a uživatel o něm neví:
 * - error interceptor by při chybě ukázal hlášku — třeba „chyba spojení", když se síť
 *   po probuzení počítače teprve rozbíhá, nebo při 401 odvedl na login uprostřed čtení.
 *   O vypršelém přihlášení má rozhodnout AuthGuard a další skutečný požadavek, ne tenhle;
 * - interceptory ani nic z jejich grafu se tu nekonstruuje, takže sem nemůže zatáhnout
 *   cyklus přes `TranslateService` (angular-conventions §8b).
 *
 * Token se proto přikládá ručně, stejně jako u posledního pingu času čtení.
 */
@Injectable({ providedIn: 'root' })
export class MediaAccessService {

  protected baseUrl = `${webApiUrl}/Auth`;

  private http: HttpClient;

  constructor(
    backend: HttpBackend,
  ) {
    this.http = new HttpClient(backend);
  }

  refresh(token: string, url: string = `${this.baseUrl}/MediaAccess`): Observable<void> {
    return this.http.get<void>(url, {
      headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
    });
  }
}
